export enum CalculationRouteNav {
  MaterialCost = "material",
  Installation = "installation",
  Service = "service",
  Rental = "rental",
  TotalOverview = "total",
}
